import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

const MARKET_PULSE_MIN_CONFIRMED_ORDERS = 50;

export type MarketPulseVisibility = {
  visible: boolean;
  confirmedCount: number;
};

/**
 * Returns whether the home-page Market Pulse section should be visible.
 * It is hidden until the platform has a meaningful number of confirmed
 * (released) transactions so the trend data is not misleading.
 */
export const getMarketPulseVisibility = createServerFn({ method: "GET" }).handler(
  async (): Promise<MarketPulseVisibility> => {
    try {
      const supa = createClient<Database>(
        process.env.SUPABASE_URL!,
        process.env.SUPABASE_PUBLISHABLE_KEY!,
        { auth: { storage: undefined, persistSession: false, autoRefreshToken: false } },
      );
      const { count, error } = await supa
        .from("transactions")
        .select("id", { count: "exact", head: true })
        .eq("status", "released");
      if (error) {
        console.error("[market-pulse] count failed:", error);
        return { visible: false, confirmedCount: 0 };
      }
      const confirmedCount = count ?? 0;
      return { visible: confirmedCount >= MARKET_PULSE_MIN_CONFIRMED_ORDERS, confirmedCount };
    } catch (e) {
      console.error("[market-pulse] handler failed:", e);
      return { visible: false, confirmedCount: 0 };
    }
  },
);
